<template>
    <v-card class="default_card" elevation="0">
        <v-card-title>
            {{ title ? `${title} - ${titleStep}` : `${titleStep}` }}
            <span v-if="convertFec && convertFec.totalDebitCredit" style="color: red">
                {{ " Ecritures non équilibrés, écart= " + convertFec.totalDebitCredit }}
            </span>
        </v-card-title>
        <v-card-text style="height: calc(100vh - 15rem); overflow-y: auto">
            <v-row no-gutters class="pb-2">
                <v-col cols="4">
                    <v-btn v-show="wizardStep >= 0" @click="previous()" elevation="0" size="small">
                        Précédent
                    </v-btn>
                </v-col>
                <v-spacer />
                <v-col cols="4" class="d-flex justify-end">
                    <v-btn
                        :disabled="disabledNext()"
                        @click="next()"
                        elevation="0"
                        v-if="wizardStep >= -1 && wizardStep <= 7"
                        :loading="loadingUpsertAAI"
                        size="small"
                    >
                        Suivant
                    </v-btn>
                    <v-btn
                        @click="valid()"
                        elevation="0"
                        :disabled="!isValid() || loadingImport"
                        :loading="loadingImport"
                        v-else
                        data-cy="ImportFEC-valid"
                        size="small"
                        >Valider</v-btn
                    >
                </v-col>
                <!-- <v-btn  //? temporary Maxime
                        color="secondary"
                        rounded
                         size="small"
                        :disabled="disabledNext()"
                        @click="testMaxime()"
                        elevation="0"
                        :loading="loadingUpsertAAI"
                    >
                        Import Auto
                    </v-btn> -->
            </v-row>
            <v-window
                v-model="wizardStep"
                touchless
                style="height: calc(100vh - 19rem); overflow-y: auto"
            >
                <!--  file choice -->
                <v-window-item :value="-1">
                    <v-row no-gutters>
                        <v-col cols="12" v-if="!id">
                            <v-text-field-filled
                                label="Fichier"
                                v-model="fileName"
                                @click="$refs.inputUpload.click()"
                                prepend-icon="$attach_file"
                                class="cursor-pointer"
                                style="width: 100%; margin-right: auto; margin-left: auto"
                                density="compact"
                            />
                            <input
                                v-show="false"
                                ref="inputUpload"
                                type="file"
                                :accept="accept"
                                @change="onFileChanged"
                            />
                        </v-col>
                        <v-col v-show="dataRead && !outputData && title" cols="12" class="mt-3">
                            <v-alert type="error"> Le fichier est vide </v-alert>
                        </v-col>
                        <v-col v-show="alreadyImported" cols="12" class="mt-3">
                            <v-alert type="error"> Ce fichier a déjà été importé </v-alert>
                        </v-col>
                        <v-col v-show="wrongFormat" cols="12" class="mt-3">
                            <v-alert type="error">
                                Ce fichier n'est pas au format FEC. Veuillez choisir un autre
                                fichier.
                            </v-alert>
                            <v-alert type="error">
                                {{ readingError }}
                            </v-alert>
                        </v-col>
                        <v-col cols="12" v-if="dataAvailable" class="mt-3">
                            <v-text-field-filled
                                v-model="convertFec.importTitle"
                                label="Nom de l'import"
                                :readonly="!editable"
                                density="compact"
                            />
                        </v-col>
                        <div class="w-100" />
                        <v-col cols="6" v-if="dataAvailable && !payslipOnly" class="mt-3">
                            <v-select-filled
                                v-model="accountingPeriod"
                                :items="accountingPeriods"
                                label="Exercice comptable"
                                :item-title="computeAccountingPeriodText"
                                item-value="id"
                                return-object
                                outlined
                                dense
                            ></v-select-filled>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" class="mt-3">
                            <v-select-filled
                                v-model="keyColumn"
                                :items="keyColumns"
                                label="Colonne écriture"
                                v-if="mode !== 'payslip'"
                                :readonly="!editable"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </v-window-item>
                <!--  column identification -->
                <v-window-item :value="0" v-if="dataAvailable">
                    <ColumnCorrespondence
                        ref="columnComponent"
                        v-if="wizardStep > -1"
                        :result="{ data: outputData.rawData, file: { name: 'fecImport' } }"
                        :resultIsArray="true"
                        :extension="extension"
                        :actions="actions"
                        :ruleManager="ruleManager"
                        :formatColumns="formatColumns"
                        :columnMapping="convertFec.columnMapping"
                        :dateVerifWording="'PieceDate'"
                        :requireDateVerification="true"
                        :validateAccountingDates="true"
                        @columns-chosen="onColumnsChosen($event)"
                    />
                </v-window-item>
                <!--  accountable account mapping-->
                <v-window-item v-if="dataAvailable" :value="1">
                    <v-row no-gutters>
                        <v-col style="max-height: 70vh" class="px-2 flex-shrink-0 flex-grow-1">
                            <v-switch
                                v-model="onlyUndefinedAccountable"
                                :label="'Comptes comptables non trouvés uniquement'"
                            />
                            <v-btn
                                class="force-valid-compte-nums-btn mt-3 mb-4"
                                size="small"
                                elevation="0"
                                :disabled="isForceValidCompteNumsInProgress"
                                @click="forceValidCompteNums()"
                                data-cy="ImportFEC-forceValidCompteNumsBtn"
                            >
                                {{ forceValidCompteNumsBtnLabel }}
                                <v-icon size="small" right dark>$fa-angle-double-right</v-icon>
                            </v-btn>
                            <v-list width="100%">
                                <v-list-item class="oss-list-item mb-2">
                                    <v-row no-gutters>
                                        <v-col cols="1" class="d-flex justify-start"> </v-col>
                                        <v-col cols="3"> Compte (Fichier) </v-col>
                                        <v-col :cols="editable ? 4 : 3"> Libellé (Fichier) </v-col>
                                        <v-col
                                            :cols="editable ? 2 : 1"
                                            class="d-flex justify-center"
                                        >
                                            Compte (bobbee)
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="d-flex justify-center"
                                            v-if="!editable"
                                        >
                                            Libellé (bobbee)
                                        </v-col>
                                        <v-col :cols="2" class="d-flex justify-start"> </v-col>
                                    </v-row>
                                </v-list-item>
                                <v-virtual-scroll
                                    :item-height="56"
                                    :items="filteredCompteNums"
                                    class="v-window-1-v-virtual-scroll"
                                    :class="{
                                        'v-window-1-v-virtual-scroll--hidden':
                                            isForceValidCompteNumsInProgress,
                                    }"
                                    height="calc(70vh - 16.5rem)"
                                    bench="2"
                                    data-cy="ImportFEC-window1VirtualScroll"
                                >
                                    <template v-slot="{ item, index }">
                                        <v-list-item
                                            class="mb-2"
                                            @click="selectedAccountableAccountIndex = index"
                                            :style="
                                                index === selectedAccountableAccountIndex
                                                    ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                    : ''
                                            "
                                            rounded="pill"
                                            border="sm"
                                        >
                                            <v-row no-gutters>
                                                <v-col cols="1" class="d-flex justify-start">
                                                    <ImportFECTooltip
                                                        message="G"
                                                        v-if="
                                                            isGeneralAccountableAccount(item.name)
                                                        "
                                                    />
                                                </v-col>
                                                <v-col :cols="3">
                                                    <span>
                                                        {{
                                                            displayNominalAccountableAccount(
                                                                item.name,
                                                            )
                                                        }}
                                                    </span>
                                                    <template
                                                        v-for="(acc, index) of subAccount(
                                                            item.name,
                                                        )"
                                                        :key="index"
                                                    >
                                                        <span
                                                            v-if="acc === '0'"
                                                            style="margin: -2px; padding: 0"
                                                        >
                                                            0
                                                        </span>
                                                        <span v-else>
                                                            {{ acc }}
                                                        </span>
                                                        <!-- <span
                                                            v-else
                                                            style="
                                                                color: #e67e22;
                                                                font-weight: bold;
                                                                padding: 0;
                                                            "
                                                        >
                                                            {{ acc }}
                                                        </span> -->
                                                    </template>
                                                </v-col>
                                                <v-col :cols="editable ? 4 : 3">
                                                    {{ getOriginalDescription(item) }}
                                                </v-col>
                                                <v-col
                                                    :cols="editable ? 2 : 1"
                                                    class="d-flex justify-center"
                                                >
                                                    {{ item.oss360AAName ? item.oss360AAName : "" }}
                                                </v-col>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex justify-center align-center"
                                                    v-if="!editable"
                                                >
                                                    {{ getOss360AAWording(item) }}
                                                </v-col>
                                                <v-col cols="1" class="d-flex justify-start">
                                                    <ImportFECTooltip
                                                        message="G"
                                                        v-if="item.isGeneral"
                                                    />
                                                    <v-avatar
                                                        color="secondary"
                                                        :class="
                                                            item.isGeneral
                                                                ? 'ml-2 text-white'
                                                                : 'text-white'
                                                        "
                                                        size="16"
                                                        v-text="'M'"
                                                        v-if="item.fromAFMapping"
                                                    />
                                                </v-col>
                                                <v-col cols="1" class="d-flex justify-end">
                                                    <v-btn-icon
                                                        v-if="!!item.oss360AAName && item.validated"
                                                        color="primary"
                                                        size="16"
                                                        icon="$fa-check-circle"
                                                        class="mr-1"
                                                        @click.stop="
                                                            validateAccountableChoice(item)
                                                        "
                                                    />
                                                    <v-btn-icon
                                                        v-else
                                                        icon="$fa-circle"
                                                        size="16"
                                                        class="mr-1"
                                                        @click.stop="
                                                            validateAccountableChoice(item)
                                                        "
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-list-item>
                                    </template>
                                </v-virtual-scroll>
                            </v-list>
                        </v-col>
                        <v-col
                            class="d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0"
                            height="100%"
                            v-if="
                                editable &&
                                selectedAccountableAccount &&
                                !selectedAccountableAccount.fromAFMapping
                            "
                        >
                            <v-icon>$fa-arrow-left</v-icon>
                        </v-col>
                        <v-col
                            class="px-2 align-self-center flex-shrink-0 flex-grow-1"
                            style="max-height: 59vh"
                            v-if="
                                editable &&
                                selectedAccountableAccount &&
                                !selectedAccountableAccount.fromAFMapping
                            "
                        >
                            <v-row no-gutters>
                                <v-col
                                    cols="4"
                                    class="pe-2"
                                    v-if="selectedAccountableAccount?.oss360AAName?.startsWith('164')"
                                >
                                    <v-select-filled
                                        v-model="selectedAccountableAccount.tagType"
                                        :items="tagTypes"
                                        :disabled="selectedAccountableAccount.disabledTag"
                                        density="compact"
                                        item-title="text"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field-filled
                                        v-model="selectedAccountableAccount.tag"
                                        outlined
                                        :disabled="
                                            selectedAccountableAccount.disabledTag ||
                                            !selectedAccountableAccount.tagType
                                        "
                                        v-if="selectedAccountableAccount"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-btn
                                    @click="
                                        showMoreAccountableAccount = !showMoreAccountableAccount
                                    "
                                    elevation="0"
                                    class="d-flex my-2"
                                    size="small"
                                >
                                    Montrer {{ showMoreAccountableAccount ? "moins" : "plus" }} de
                                    comptes comptables
                                    <v-icon location="end">{{
                                        showMoreAccountableAccount ? "$fa-minus" : "$fa-plus"
                                    }}</v-icon>
                                </v-btn>
                            </v-row>
                            <v-row no-gutters>
                                <v-list
                                    style="
                                        max-height: calc(59vh - 8rem);
                                        overflow-y: auto;
                                        width: 100%;
                                    "
                                >
                                    <v-list-item
                                        v-for="(acc, index) in filteredAccountableAccounts"
                                        :key="index"
                                        class="my-1"
                                        :style="
                                            selectedAccountableAccount.oss360AAName === acc.name
                                                ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                : ''
                                        "
                                        @click="setAccountableAccount(acc.name)"
                                        border="sm"
                                        rounded="pill"
                                    >
                                        <!-- <template v-if="item.subAccountableAccountOf" class="my-0">
                                            <v-icon>$subdirectory_arrow_right</v-icon>
                                        </template>
                                        <template two-line>
                                            <v-list-item-title>{{ item.displayName || item.name || 'XXX' }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                                        </template> -->
                                        <v-row no-gutters>
                                            <v-col cols="2" v-if="acc.subAccountableAccountOf">
                                                <v-icon>$subdirectory_arrow_right</v-icon>
                                            </v-col>
                                            <v-col cols="2" v-else>
                                                {{ acc.displayName || acc.name }}
                                            </v-col>
                                            <v-col cols="10">
                                                <ImportFECTooltip message="O" v-if="acc.original" />
                                                <ImportFECTooltip message="N" v-else-if="!acc.id" />
                                                <ImportFECTooltip message="E" v-else />
                                                {{ acc.description
                                                }}<span v-if="acc.original">
                                                    (Compte d'origine)</span
                                                >
                                                <span v-if="!acc.original && !acc.id">
                                                    (Nouveau compte)</span
                                                >
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </v-list>
                            </v-row>
                        </v-col>
                        <v-col
                            class="px-2 align-self-center flex-shrink-0 flex-grow-1"
                            style="max-height: 50vh; overflow-y: auto"
                            v-if="
                                selectedAccountableAccount &&
                                selectedAccountableAccount.fromAFMapping
                            "
                        >
                            <div>
                                Compte comptable bobbee à partir de la table de correspondance du
                                cabinet
                            </div>
                            <v-list style="max-height: 40vh; overflow-y: auto">
                                <v-list-item
                                    class="oss-list-item"
                                    :style="'background: rgba(109, 192, 189, 0.3) !important'"
                                >
                                    <v-row no-gutters>
                                        <v-col cols="2">
                                            {{ selectedAccountableAccount.oss360AAName || "" }}
                                        </v-col>
                                        <v-col cols="10">
                                            {{ selectedOSS360AA.description }}
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-window-item>
                <!-- type choice -->
                <v-window-item v-if="dataAvailable" :value="2">
                    <div class="d-flex flex-row">
                        <div
                            style="
                                height: calc(100vh - 19rem);
                                overflow-y: auto;
                                min-width: max-content;
                            "
                        >
                            <v-tabs v-model="journalCodeSelected" direction="vertical">
                                <v-tab
                                    v-for="(log, index) in logs"
                                    :value="index"
                                    class="d-flex justify-start"
                                    style="border-radius: 6px"
                                >
                                    <v-badge
                                        color="red"
                                        :content="getAAKeyWithoutTypeCount(log)"
                                        bordered
                                        :model-value="!!getAAKeyWithoutTypeCount(log)"
                                    >
                                        <v-avatar
                                            :color="
                                                journalCodeSelected === index ? 'secondary' : 'grey'
                                            "
                                            size="small"
                                        >
                                            {{ log.shortName }}
                                        </v-avatar>
                                    </v-badge>

                                    <span class="ml-2">{{
                                        log.type ? $t("accountingItem.type.") + log.type : log.name
                                    }}</span>
                                </v-tab>
                            </v-tabs>
                        </div>
                        <div style="height: calc(100vh - 19rem); overflow-y: auto; flex-grow: 1">
                            <v-tabs-window v-model="journalCodeSelected" class="ml-2">
                                <v-window-item
                                    v-for="(log, index) in logs"
                                    style="background: #fff"
                                    :value="index"
                                >
                                    <v-row no-gutters>
                                        <!-- <v-col cols="12" class="d-flex align-center justify-start h6 pa-3" style="background: #FFF; border-radius: 6px;"> -->
                                        <v-col
                                            class="d-flex align-center justify-start h6 pa-3"
                                            style="background: #fff; border-radius: 6px"
                                        >
                                            <!-- <div>{{ log.shortName }} | {{ log.name }}</div> -->
                                            <v-switch
                                                v-model="onlyUndefinedTypes"
                                                :label="'Non affectés'"
                                                hide-details
                                                class="mt-0"
                                            />
                                            <v-switch
                                                v-model="log.import"
                                                :label="'Importer le journal'"
                                                hide-details
                                                class="pl-2 mt-0"
                                            />
                                            <v-text-field-filled
                                                v-model="log.importName"
                                                label="Nom de journal"
                                                outlined
                                                v-show="log.import"
                                                hide-details
                                                class="pl-2 mt-0"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col
                                            class="d-flex align-center justify-end pa-3"
                                            style="background: #fff; border-radius: 6px"
                                        >
                                            <!-- <v-spacer></v-spacer> -->
                                            <v-chip-group
                                                v-model="log.selectedTypes"
                                                multiple
                                                mandatory
                                                selected-class="primary text-white"
                                                :key="'selectedTypes' + index + refreshKey"
                                                @update:model-value="onLogTypesChanged(log)"
                                            >
                                                <v-chip
                                                    v-for="(type, i) in log.types"
                                                    :key="type"
                                                    :value="i"
                                                    size="small"
                                                >
                                                    {{ $t("accountingItem.type." + type) }}
                                                </v-chip>
                                            </v-chip-group>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="px-2">
                                            <v-list class="ma-0 pa-0" style="background: #fff">
                                                <v-list-item
                                                    v-for="(aaKey, index) in log.aaKeys"
                                                    :key="index"
                                                    class="my-2 pa-2"
                                                    v-show="
                                                        aaKey.type === undefined ||
                                                        !onlyUndefinedTypes
                                                    "
                                                    :model-value="index"
                                                >
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            class="d-flex align-center justify-start subtitle-1"
                                                        >
                                                            {{
                                                                aaKey.transactions.length +
                                                                " écriture(s)"
                                                            }}
                                                            <v-spacer />
                                                            <v-chip-group
                                                                v-model="aaKey.type"
                                                                :key="
                                                                    'keyTypes' + index + refreshKey
                                                                "
                                                                @update:model-value="refreshKey++"
                                                                selected-class="primary text-white"
                                                                v-if="aaKey.possibleTypes.length"
                                                            >
                                                                <v-chip
                                                                    v-for="(
                                                                        type, j
                                                                    ) in aaKey.possibleTypes"
                                                                    :key="type.type"
                                                                    :value="j"
                                                                    v-show="!type.disabled"
                                                                    size="small"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "accountingItem.type." +
                                                                                type.type,
                                                                        )
                                                                    }}
                                                                </v-chip>
                                                            </v-chip-group>
                                                            <v-chip
                                                                color="orange"
                                                                v-else
                                                                size="small"
                                                            >
                                                                {{
                                                                    $t(
                                                                        "accountingItem.type." +
                                                                            "MISCELLANEOUS_OPERATION",
                                                                    )
                                                                }}
                                                            </v-chip>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-divider />
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            class="outline"
                                                            @click.stop="
                                                                aaKey.showDetails =
                                                                    !aaKey.showDetails
                                                            "
                                                        >
                                                            <v-icon size="small">{{
                                                                aaKey.showDetails
                                                                    ? "$fa-chevron-down"
                                                                    : "$fa-chevron-up"
                                                            }}</v-icon>
                                                            {{ aaKey.name }}
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            class="outline"
                                                            v-if="aaKey.showDetails"
                                                        >
                                                            <v-divider />
                                                            <div
                                                                v-for="(
                                                                    transaction, index
                                                                ) in aaKey.transactions"
                                                                :key="index"
                                                            >
                                                                {{ transaction.wording }}
                                                            </div>
                                                        </v-col>
                                                        <!-- <v-col cols="12" class="outline">
                                                        </v-col> -->
                                                    </v-row>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                            </v-tabs-window>
                        </div>
                    </div>
                </v-window-item>
                <!-- bank choice -->
                <v-window-item v-if="dataAvailable" :value="3">
                    <v-row no-gutters>
                        <v-col cols="8" class="px-2 flex-shrink-0 flex-grow-1">
                            <v-list width="100%" style="max-height: 50vh; overflow-y: auto">
                                <v-list-item class="oss-list-item my-1">
                                    <v-row no-gutters>
                                        <v-col> Compte banque du FEC </v-col>
                                        <v-col class="d-flex justify-center">
                                            Compte banque bobbee
                                        </v-col>
                                        <v-col cols="1"> </v-col>
                                        <v-col cols="1" class="d-flex justify-end"> </v-col>
                                    </v-row>
                                </v-list-item>
                                <v-list-item
                                    v-for="(bankAccount, index) in bankAccounts"
                                    :key="index"
                                    class="my-1"
                                    @click="bankSelected = index"
                                    :style="
                                        index === bankSelected
                                            ? 'background: rgba(109, 192, 189, 0.3) !important'
                                            : ''
                                    "
                                >
                                    <v-row no-gutters>
                                        <v-col>
                                            {{ bankAccount.name }}
                                        </v-col>
                                        <v-col class="d-flex justify-center">
                                            {{ bankAccount ? bankAccount.outName : "" }}
                                        </v-col>
                                        <v-col cols="1">
                                            <v-icon
                                                color="primary"
                                                v-if="bankAccount.outName"
                                                size="small"
                                            >
                                                {{ bankAccount.id ? "$fa-database" : "$fa-plus" }}
                                            </v-icon>
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-end">
                                            <v-icon color="primary" v-if="!!bankAccount.id">
                                                $fa-check-circle
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col
                            class="d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0"
                            height="100%"
                            v-if="editable"
                        >
                            <v-icon>$fa-arrow-left</v-icon>
                        </v-col>
                        <v-col cols="3" class="px-2 flex-shrink-0 flex-grow-1" v-if="editable">
                            <v-list width="100%" style="max-height: 50vh; overflow-y: auto">
                                <v-list-item
                                    v-for="(bankAccount, index) in companyBankAccounts"
                                    :key="index"
                                    class="oss-list-item my-1"
                                    @click="
                                        bankAccounts[bankSelected].id = bankAccount.id;
                                        bankAccounts[bankSelected].outName = bankAccount.name;
                                        bankAccounts[bankSelected].lastDate =
                                            bankAccount.startAuthorizedDate;
                                    "
                                >
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-avatar
                                                color="primary lighten-2"
                                                class="text-white"
                                                size="16"
                                                :v-text="bankAccount.id ? 'E' : 'N'"
                                            />
                                            {{
                                                (bankAccount.bank
                                                    ? bankAccount.bank.name + " - "
                                                    : "") + bankAccount.name
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </v-list>
                            <v-row no-gutters class="pt-2">
                                <v-col>
                                    <v-text-field-filled
                                        v-model="newBankName"
                                        label="Nouvelle Banque"
                                        outlined
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="1" class="d-flex align-center justify-center">
                                    <v-btn-icon
                                        icon="$fa-plus-circle"
                                        color="primary"
                                        @click="createNewBank()"
                                        size="small"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-window-item>
                <!-- user choice -->
                <v-window-item v-if="dataAvailable" :value="4">
                    <v-row no-gutters>
                        <v-col cols="7" class="px-2 flex-shrink-0 flex-grow-1">
                            <v-list width="100%">
                                <v-list-item class="oss-list-item my-1">
                                    <v-row no-gutters>
                                        <v-col> Nom affiché dans le FEC </v-col>
                                        <v-col> Nom enregistré chez bobbee </v-col>
                                        <v-col cols="1"> </v-col>
                                        <v-col cols="1"> </v-col>
                                    </v-row>
                                </v-list-item>
                            </v-list>
                            <div style="max-height: 45vh; overflow-y: auto">
                                <v-list width="100%" style="height: calc(100vh-400px)">
                                    <v-list-item
                                        v-for="(user, index) in users"
                                        :key="index"
                                        class="my-1"
                                        @click="setUserSelected(index)"
                                        :style="
                                            index === userSelected
                                                ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                : ''
                                        "
                                    >
                                        <v-row no-gutters>
                                            <v-col>
                                                {{ user.key || user.name }}
                                            </v-col>
                                            <v-col>
                                                {{ getUserDisplayName(user) }}
                                            </v-col>
                                            <v-col cols="1">
                                                <v-icon
                                                    color="primary"
                                                    v-if="user.firstname"
                                                    size="small"
                                                >
                                                    {{ user.id ? "$fa-database" : "$fa-plus" }}
                                                </v-icon>
                                            </v-col>
                                            <v-col cols="1" class="d-flex justify-end">
                                                <v-icon color="primary" v-if="!!user.lastname">
                                                    $fa-check-circle
                                                </v-icon>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </v-col>
                        <v-col
                            class="d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0"
                            height="100%"
                            v-if="editable"
                        >
                            <v-icon>$fa-arrow-left</v-icon>
                        </v-col>
                        <v-col cols="4" class="px-2 flex-shrink-0 flex-grow-1" v-if="editable">
                            <v-row no-gutters class="pt-2">
                                <v-col class="px-1">
                                    <v-text-field-filled
                                        v-model="newUser.firstname"
                                        label="Prénom"
                                        outlined
                                        hide-details
                                        @keyup.enter="
                                            newUser && newUser.firstname && newUser.lastname
                                                ? createUser()
                                                : null
                                        "
                                        density="compact"
                                    />
                                </v-col>
                                <v-col class="px-1">
                                    <v-text-field-filled
                                        v-model="newUser.lastname"
                                        label="Nom"
                                        outlined
                                        hide-details
                                        @keyup.enter="
                                            newUser && newUser.firstname && newUser.lastname
                                                ? createUser()
                                                : null
                                        "
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="1" class="d-flex align-center justify-center">
                                    <v-btn-icon
                                        icon="$fa-plus-circle"
                                        color="primary"
                                        size="small"
                                        @click.stop="createUser()"
                                    />
                                </v-col>
                            </v-row>
                            <div style="height: calc(100vh-456px); overflow-y: auto">
                                <v-list width="100%">
                                    <v-list-item
                                        v-for="(user, index) in filteredCompanyUsers"
                                        :key="index"
                                        class="my-1"
                                        @click="addUser(user)"
                                    >
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                {{ getUserDisplayName(user) }}
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </v-col>
                    </v-row>
                </v-window-item>
                <!-- company choice -->
                <v-window-item v-if="dataAvailable" :value="5">
                    <v-row no-gutters>
                        <v-col
                            cols="5"
                            class="px-2 flex-shrink-0 flex-grow-1"
                            style="max-height: 60vh; overflow-y: auto"
                        >
                            <v-btn
                                class="mt-4"
                                size="small"
                                elevation="0"
                                @click="autoFillCompany()"
                                :disabled="!editable"
                            >
                                Compléter automatiquement
                                <v-icon size="small" right dark>$fa-angle-double-right</v-icon>
                            </v-btn>
                            <v-list
                                width="100%"
                                v-if="companies.length"
                                style="max-height: 50vh; overflow-y: auto"
                            >
                                <v-list-item class="my-1" border="sm" rounded="pill">
                                    <v-row no-gutters>
                                        <v-col> Nom affiché dans le FEC </v-col>
                                        <v-col class="d-flex justify-center">
                                            Nom enregistré chez bobbee
                                        </v-col>
                                        <v-col cols="2"> </v-col>
                                    </v-row>
                                </v-list-item>
                                <v-list-item
                                    v-for="(company, index) in companies"
                                    :key="index"
                                    class="my-1"
                                    @click="compCompaniesSelected = index"
                                    :style="
                                        index === compCompaniesSelected
                                            ? 'background: rgba(109, 192, 189, 0.3) !important'
                                            : ''
                                    "
                                    border="sm"
                                    rounded="pill"
                                >
                                    <v-row no-gutters>
                                        <v-col>
                                            {{ company.key || company.name }}
                                        </v-col>
                                        <v-col class="d-flex justify-center">
                                            {{ company && company.outName ? company.outName : "" }}
                                        </v-col>
                                        <v-col cols="1">
                                            <v-tooltip location="start">
                                                <template v-slot:activator="{ props }">
                                                    <v-icon
                                                        color="primary"
                                                        v-if="company.outName"
                                                        size="small"
                                                        v-bind="props"
                                                    >
                                                        {{
                                                            company.id ? "$fa-database" : "$fa-plus"
                                                        }}
                                                    </v-icon>
                                                </template>
                                                <span>{{
                                                    company.id
                                                        ? "Société existante"
                                                        : "Société créée avec l'import"
                                                }}</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-end">
                                            <v-icon v-if="company.outName && company.outName">
                                                $fa-check-circle
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col
                            class="d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0"
                            height="100%"
                            v-if="editable"
                        >
                            <v-icon>$fa-arrow-left</v-icon>
                        </v-col>
                        <v-col cols="6" class="px-2 flex-shrink-0 flex-grow-1" v-if="editable">
                            <CompaniesTable
                                :showGenericCompany="companyType.supplier"
                                :showSupplierCompanies="companyType.supplier"
                                :showConsumerCompanies="companyType.customer"
                                :showCustomerCompanies="companyType.customer"
                                :showExistingCompanies="false"
                                :parentCompanyId="companyId"
                                :company="
                                    compCompaniesSelected >= 0 &&
                                    compCompaniesSelected < companies.length
                                        ? companies[compCompaniesSelected].name
                                        : ''
                                "
                                :wizardMode="true"
                                @select-company="setThirdParty($event)"
                                :key="wizardStep"
                                v-if="wizardStep === 5"
                            />
                        </v-col>
                    </v-row>
                </v-window-item>
                <!-- synthèse -->
                <v-window-item v-if="dataAvailable" :value="6">
                    <v-row class="py-3" no-gutters>
                        <v-col cols="3" class="px-2 d-flex justify-center align-center">
                            {{ status }}
                        </v-col>
                        <v-col cols="3" class="px-2 d-flex justify-center align-center">
                            <v-switch
                                v-model="onlyError"
                                hide-details
                                :label="'Erreurs uniquement'"
                            />
                            <v-btn
                                @click="correctDateDifferenceErrors()"
                                elevation="0"
                                v-if="containsDateDifferenceErrors"
                                class="ml-2"
                                size="x-small"
                            >
                                Corriger
                            </v-btn>
                        </v-col>
                        <v-col cols="3" class="px-2 justify-center align-center">
                            <v-switch
                                v-model="onlyWarning"
                                hide-details
                                :label="'Alertes uniquement'"
                            />
                        </v-col>
                        <v-col cols="3" class="px-2 justify-center align-center">
                            <v-switch
                                v-model="onlyAutoLettering"
                                hide-details
                                :label="'Montrer les lettrages auto'"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="pt-3" no-gutters>
                        <v-col cols="12" class="px-2 justify-center">
                            <v-data-table
                                :headers="headers"
                                :items="filteredAccountingItems"
                                class="table"
                                fixed-header
                                height="calc(100vh - 410px)"
                            >
                                <!-- BODY -->
                                <template v-slot:item="props">
                                    <tr :key="'AI_' + props.item.index" style="background: #ededed">
                                        <template v-if="props.item.errorCount">
                                            <td colspan="4" style="background-color: #ff6b6b">
                                                <strong>{{
                                                    getAccountingItemTitle(props.item)
                                                }}</strong>
                                            </td>
                                            <td
                                                colspan="8"
                                                style="background-color: #ff6b6b"
                                                class="align-center"
                                            >
                                                <v-select-filled
                                                    v-model="props.item.selectedDate"
                                                    :items="props.item.availableDates"
                                                    hide-details
                                                    label="Date #####"
                                                    @update:model-value="
                                                        onAccountingItemDateChanged(props.item)
                                                    "
                                                    v-if="
                                                        props.item.availableDates &&
                                                        props.item.availableDates.length
                                                    "
                                                    density="compact"
                                                />
                                                <v-select-filled
                                                    v-model="props.item.type"
                                                    :items="props.item.compatibleTypes"
                                                    :item-title="getAccountingItemTypeText"
                                                    hide-details
                                                    @update:model-value="
                                                        onAccountingItemTypeChanged(props.item)
                                                    "
                                                    v-if="
                                                        props.item.typeError ||
                                                        props.item.datesAreBeforePeriod
                                                    "
                                                    density="compact"
                                                />
                                            </td>
                                        </template>
                                        <td
                                            v-else
                                            colspan="12"
                                            :style="
                                                props.item.warningCount
                                                    ? 'background-color:orange'
                                                    : ''
                                            "
                                        >
                                            <strong>{{
                                                getAccountingItemTitle(props.item)
                                            }}</strong>
                                        </td>
                                    </tr>

                                    <tr v-for="row in props.item.rows" :key="row.index">
                                        <td class="text-left" :style="getCellStyle(row, 'type')">
                                            <div>{{ $t("accountingItem.type." + row.type) }}</div>
                                            <div v-if="row.typeError">{{ row.typeError }}</div>
                                        </td>

                                        <td class="text-center" :style="getCellStyle(row, 'date')">
                                            <div>{{ formatDate(row.date) }}</div>
                                            <div v-if="row.dateError">{{ row.dateError }}</div>
                                            <div v-if="row.dateWarning">{{ row.dateWarning }}</div>
                                        </td>

                                        <td
                                            class="text-center"
                                            :style="getCellStyle(row, 'accountableAccount')"
                                        >
                                            <div>{{ row.accountableAccount }}</div>
                                            <div v-if="row.accountableAccountError">
                                                {{ row.accountableAccountError }}
                                            </div>
                                            <div v-if="row.accountableAccountWarning">
                                                {{ row.accountableAccountWarning }}
                                            </div>
                                        </td>

                                        <td
                                            class="text-left"
                                            :style="getCellStyle(row, 'thirdParty')"
                                        >
                                            <div>{{ row.thirdParty ? row.thirdParty : "" }}</div>
                                            <div v-if="row.thirdPartyError">
                                                {{ row.thirdPartyError }}
                                            </div>
                                        </td>

                                        <td class="text-left" :style="getCellStyle(row, 'wording')">
                                            <div>{{ row.wording }}</div>
                                            <div v-if="row.wordingError">
                                                {{ row.wordingError }}
                                            </div>
                                        </td>

                                        <td class="text-right" :style="getCellStyle(row, 'debit')">
                                            <div>{{ getRowDebit(row) }}</div>
                                            <div v-if="row.debitError">{{ row.debitError }}</div>
                                        </td>

                                        <td class="text-right" :style="getCellStyle(row, 'credit')">
                                            <div>{{ getRowCredit(row) }}</div>
                                            <div v-if="row.creditError">{{ row.creditError }}</div>
                                        </td>

                                        <td
                                            class="text-center"
                                            :style="getCellStyle(row, 'lettering')"
                                        >
                                            <div>{{ row.lettering || "" }}</div>
                                            <div v-if="row.letteringError">
                                                {{ row.letteringError }}
                                            </div>
                                            <div v-if="row.letteringWarning">
                                                {{ row.letteringWarning }}
                                            </div>
                                        </td>

                                        <td class="text-center">
                                            <div>
                                                <v-icon color="primary" v-if="row.reconciliation"
                                                    >$check_circle</v-icon
                                                >
                                                <p v-else-if="row.reconciliationId">
                                                    {{ row.reconciliationId }}
                                                </p>
                                            </div>
                                            <div v-if="row.reconciliationError">
                                                {{ row.reconciliationError }}
                                            </div>
                                        </td>
                                        <!-- <td
                                            class="text-center"
                                        ><div><v-icon color="primary" v-if="row.vatDeclaration">$check_circle</v-icon></div><div v-if="row.vatDeclarationError">{{row.vatDeclarationError}}</div></td> -->
                                    </tr>
                                    <tr :key="'AIT_' + props.item.index">
                                        <td colspan="3" style="text-align: left">
                                            <strong>Différence et totaux</strong>
                                        </td>

                                        <td
                                            class="text-center"
                                            :style="getCellStyle(props.item, 'difference')"
                                        >
                                            <strong>{{ props.item.difference }}</strong>
                                            <strong v-if="props.item.differenceError">{{
                                                props.item.differenceError
                                            }}</strong>
                                        </td>

                                        <td />

                                        <td class="text-right">
                                            <strong>{{
                                                newCommonFormatCurrency(
                                                    props.item.totalDebit,
                                                    undefined,
                                                )
                                            }}</strong>
                                        </td>

                                        <td class="text-right">
                                            <strong>{{
                                                newCommonFormatCurrency(
                                                    props.item.totalCredit,
                                                    undefined,
                                                )
                                            }}</strong>
                                        </td>

                                        <td />
                                        <td />
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item v-if="dataAvailable" :value="7">
                    <GeneralLedger
                        :generalLedger="generalLedger"
                        :thirdParty="generalLedgerWithThirdParty"
                        @thirdPartyChanged="onThirdPartyChanged"
                    >
                    </GeneralLedger>
                </v-window-item>
                <v-window-item v-if="dataAvailable" :value="8">
                    <v-row no-gutters>
                        <v-col cols="12"> Nom de l'import </v-col>
                        <v-col cols="12">
                            <v-text-field-filled
                                v-model="convertFec.importTitle"
                                outlined
                                :readonly="!editable"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12" v-if="dataAvailable && !payslipOnly" class="mt-3">
                            {{ getAccountingPeriodTitle() }}
                        </v-col>
                        <v-col cols="12" v-if="dataAvailable && !payslipOnly">
                            <v-select-filled
                                v-model="accountingPeriod"
                                :items="accountingPeriods"
                                label="Exercice comptable"
                                :item-title="computeAccountingPeriodText"
                                item-value="id"
                                return-object
                                density="compact"
                            />
                        </v-col>
                        <v-switch
                            v-model="importCarryForward"
                            label="Ajouter les reports à nouveau"
                            outlined
                            v-if="containsCarryForward"
                        />
                    </v-row>
                </v-window-item>
            </v-window>
        </v-card-text>
        <v-card-actions class="align-self-end">
            <v-row no-gutters>
                <v-col cols="4">
                    <v-btn v-show="wizardStep >= 0" @click="previous()" elevation="0" size="small">
                        Précédent
                    </v-btn>
                </v-col>
                <v-spacer />
                <v-col cols="4" class="d-flex justify-end">
                    <v-btn
                        :disabled="disabledNext()"
                        @click="next()"
                        elevation="0"
                        v-if="wizardStep >= -1 && wizardStep <= 7"
                        :loading="loadingUpsertAAI"
                        size="small"
                    >
                        Suivant
                    </v-btn>
                    <v-btn
                        @click="valid()"
                        elevation="0"
                        :disabled="!isValid() || loadingImport"
                        :loading="loadingImport"
                        v-else
                        size="small"
                        >Valider</v-btn
                    >
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
// import jschardet from "jschardet";
import moment from "moment-timezone";
import gql from "graphql-tag";
import _ from "lodash";
import { SHA256 } from "crypto-js";
import JSZip from "jszip";
import axios from "axios";
import { User } from "../store/store";

import { Apollo } from "@/decorators";
// import ConvertFEC from "../services/importFecService"
import ImportFecFront from "../services/importFecFront";
import excelServices from "../services/excelServices";
import ImportFECTooltip from "./ImportFECTooltip.vue";
const XLSX = require("xlsx");

import { DialogAction } from "../services/dialogAction";

import CompaniesTable from "./admin/CompaniesTable.vue";
import GeneralLedger from "./GeneralLedger.vue";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";

import { getUserDisplayName } from "../services/userServices";

import OssDataTable from "./ossComponents/ossDataTable2.vue";

import COMPANY_USERS from "../graphql/user/PartOfCompanyUsers.gql";
import ACCOUNTING_ITEM_IMPORT from "../graphql/accountingItem/AccountingItemImport.gql";
import ACCOUNTING_ITEM_IMPORT_FROM_FILE from "../graphql/accountingItem/AccountingItemImportFromFile.gql";
// import ACCOUNTABLE_ACCOUNT_MAPPINGS from '../graphql/accountableAccountMapping/AccountableAccountMappings.gql'
// import ACCOUNTABLE_ACCOUNTS_QUERY from "../graphql/accountableAccount/AccountableAccounts.gql";
import IMPORT_FEC_AUTO from "../graphql/accountingItem/ImportFECAuto.gql";
import { getDefaultAccountableAccounts } from "../../../backend/src/common/accountableAccount/accountableAccountServices";
import { ImportDocumentBase } from "./import/ImportDocumentBase";
import ColumnCorrespondence from "./import/ColumnCorrespondence.vue";
import { Component, toNative } from "vue-facing-decorator";
import { Prop, Ref } from "vue-facing-decorator";

@Component({
    components: {
        CompaniesTable,
        GeneralLedger,
        OssDataTable,
        ColumnCorrespondence,
        ImportFECTooltip,
    },
})
export class ImportFEC extends ImportDocumentBase {
    @Prop({ default: "" }) mode: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) id: string;
    @Prop({ default: "" }) repair: string;

    @State2Way("updateAccountableAccountTable", "accountableAccountTable")
    accountableAccountTable;

    @Ref("columnComponent") columnComponent;

    fileName = "";

    wizardStep = -1; // TODO: SET TO 0 IN PRODUCTION

    readingFinished: boolean = false;

    journalCodeSelected = 0;

    selectedAccountableAccountIndex = 0;

    bankSelected = 0;

    showMoreAccountableAccount = false;

    userSelected = 0;

    compCompaniesSelected = 0;

    companyBankAccountCreated = [];

    usersCompanyCreated = [];

    minimumCols = [];

    newBankName = "";

    indexViewed = 0;

    alreadyImported: boolean = false;
    wrongFormat: boolean = false;
    someDatesInvalid: boolean = false;
    readingError = "";
    unknownFormat: boolean = true;
    unknownFecTitle: string = "";
    formatWasUnkown: boolean = true;

    keyColumns = ["EcritureNum", "PieceRef"];

    // blocks = []

    convertFec = new ImportFecFront(null, this.$apollo, true); // v2 add this.companyId
    columnsAndDatesValid = false;
    validStartData = "";

    actions = {
        action: new DialogAction(),
    };

    newUser = {
        firstname: "",
        lastname: "",
    };

    onlyUndefinedAccountable: boolean = false;
    onlyUndefinedTypes: boolean = false;

    inAccountableAccounts = [];

    refreshKey = 0;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get titleStep() {
        switch (this.wizardStep) {
            case -1:
                return "Sélection du fichier";
            case 0:
                return "Correspondance des valeurs"; //
            case 1:
                return "Correspondance des comptes comptables"; // pour tous les comptesComptables attacher le compteComptable le plus proche (proposition si proche existe déjà)
            case 2:
                return "Correspondance des journaux"; // tout est préselectionné => sauf peut-être le choix entre OD de paie & OpérationDiverse  Il y a aussi Importer le journal
            case 3:
                return "Correspondance des comptes bancaires";
            case 4:
                return "Correspondance des comptes tiers 421 455 467"; // selectionner nom utilisateur ou company => si pas trouver dans bobbee le générer ?
            case 5:
                return "Correspondance clients et fournisseurs";
            case 6:
                return "Vérification";
            case 7:
                return "Balance";
            case 8:
                return "Validation";
            default:
                return "No title"; // Pas compris
        }
    }

    get accountingFirmId() {
        if (this.currentUser.company.accountingFirm) {
            return this.currentUser.company.id;
        }
        return undefined;
    }

    headers = [
        // Header du tableau
        { title: "Type", value: "type", align: "left", sortable: false },
        { title: "Date", value: "date", align: "center", sortable: false },
        {
            title: "Compte comptable",
            value: "accountableAccount",
            align: "center",
            sortable: false,
        },
        { title: "Tiers", value: "thirdParty", align: "left", sortable: false },
        { title: "Libellé", value: "wording", align: "left", sortable: false },
        { title: "Débit", value: "debit", align: "right", sortable: false },
        { title: "Crédit", value: "credit", align: "right", sortable: false },
        { title: "Lettrage", value: "lettrage", align: "center", sortable: false },
        { title: "Rapproché", value: "reconciliation", align: "center", sortable: false },
        // { title: "TVA payée", value: "vatDeclaration", align: "center", sortable: false }
    ];

    aii = null;

    tagTypes = [
        { text: "Aucun", value: 0 },
        { text: "Tag", value: 1 },
        { text: "Conserver le compte", value: 2 },
    ];

    onlyError = false;
    onlyWarning = false;
    onlyAutoLettering = false;

    loadingUpsertAAI = false;

    enableJson: boolean = true;

    get accept() {
        let accept = ".csv,.txt,.tsv,.zip,.xlsx";
        if (this.mode === "payslip") {
            accept += ",.pnm";
            if (this.enableJson) {
                accept += ",.json";
            }
        }
        return accept;
    }

    get containsCarryForward() {
        return this.convertFec.containsCarryForward();
    }

    get importCarryForward() {
        return this.convertFec.importCarryForward;
    }

    set importCarryForward(value) {
        this.convertFec.importCarryForward = value;
    }

    get keyColumn() {
        return this.convertFec?.keyColumn || "EcritureNum";
    }

    set keyColumn(value) {
        this.convertFec.keyColumn = value;
    }

    get editable() {
        if (!this.convertFec) return false;
        return this.convertFec.isEditable;
    }

    get dataAvailable() {
        if (this.id) return true;
        if (this.fileName && !this.alreadyImported) {
            if (this.convertFec && this.convertFec.data) {
                const typeList = this.convertFec.data.map((x) => x.JournalLib);
                this.minimumCols = this.getMinimuRequiredColumns(typeList);
            }
            return true;
        }
        return false;
    }

    get title() {
        // let title = "Importation ";
        let title = "";
        if (this.fileName) {
            title += this.fileName.split(".")[0];
        } else if (this.convertFec?.importTitle) {
            title += this.convertFec.importTitle;
        }
        return title;
    }

    get payslipOnly() {
        const accountingItemImport = this.aii || this.convertFec.accountingItemImport;
        if (accountingItemImport?.type) {
            return accountingItemImport.type === "SYLAE";
        }
        return this.mode === "payslip";
    }

    get journalCodes() {
        return this.convertFec.journalCodes;
    }

    get journalSelected() {
        if (this.journalCodeSelected >= 0 && this.journalCodeSelected < this.journalCodes.length) {
            switch (this.journalCodes[this.journalCodeSelected].groupSelected) {
                case "bank":
                    return ["BANK_TRANSACTION"];
                case "sales":
                    return ["SALES_INVOICE", "ZTILL_RECEIPT"];
                case "purchase":
                    return [
                        "PURCHASE_INVOICE",
                        "CURRENT_ACCOUNT",
                        "OPERATOR_ACCOUNT",
                        "EXPENSE_REPORT",
                        "PAY_SLIP",
                    ];
                case "miscellaneousOperation":
                    return ["MISCELLANEOUS_OPERATION"];
                case "carryForward":
                    return ["CARRY_FORWARD"];
                case "vat":
                    return ["VAT"];
            }
        }
        return [];
    }

    // get companyId() {
    //     this.convertFec.companyId = this.$store.state.selected_company.id
    //     return this.$store.state.selected_company.id;
    // }

    get selectedOSS360AA() {
        if (this.selectedAccountableAccount) {
            const aa = this.dbAccountableAccounts.find(
                (aa) => aa.name === this.selectedAccountableAccount.oss360AAName,
            );
            if (aa) {
                return aa;
            }
            const defaultAA =
                this.defaultAccountableAccounts[this.selectedAccountableAccount.oss360AAName];
            if (defaultAA) {
                return defaultAA;
            }
        }
        return {
            name: "XXXX",
            description: "XXXX",
        };
    }

    filterAAs(selectedAA, aaCount) {
        const sliceSelectedAA = selectedAA.slice(0, aaCount);
        const result = this.dbAccountableAccounts.filter(
            (acc) => acc.name.slice(0, aaCount) === sliceSelectedAA,
        );
        for (const key in this.defaultAccountableAccounts) {
            const formattedKey = key.padEnd(this.accountableAccountTable.aaCharacterCount, "0");
            if (!result.find((r) => r.name === formattedKey)) {
                if (formattedKey.slice(0, aaCount) === sliceSelectedAA) {
                    result.push(this.defaultAccountableAccounts[formattedKey]);
                }
            }
        }
        return result;
    }

    get filteredAccountableAccounts() {
        const selectedAA = this.selectedAccountableAccount.name;

        if (!this.selectedAccountableAccount?.name) {
            return [];
        }

        let result = this.filterAAs(selectedAA, 3);
        if (!result.length || this.showMoreAccountableAccount) {
            result = this.filterAAs(selectedAA, 2);
        }
        if (!result.length) {
            result = this.filterAAs(selectedAA, 1);
        }
        if (!result.length) {
            if (selectedAA.startsWith("C")) {
                result = this.dbAccountableAccounts.filter((acc) => acc.name.slice(0, 3) === "411");
            } else if (selectedAA.startsWith("F")) {
                result = this.dbAccountableAccounts.filter((acc) => acc.name.slice(0, 3) === "401");
            }
        }
        if (!result.length) {
            result = [...this.dbAccountableAccounts];
            for (const key in this.defaultAccountableAccounts) {
                const formattedKey = key.padEnd(this.accountableAccountTable.aaCharacterCount, "0");
                if (!result.find((r) => r.name === formattedKey)) {
                    result.push(this.defaultAccountableAccounts[formattedKey]);
                }
            }
        }
        const aaName = this.selectedAccountableAccount.name.padEnd(
            this.accountableAccountTable.aaCharacterCount,
            "0",
        );
        if (!result.find((aa) => aa.name === aaName)) {
            result.push({
                name: aaName,
                description: this.getOriginalDescription(this.selectedAccountableAccount),
                original: true,
            });
        }
        result.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        return result;
    }

    get compteNums() {
        return this.convertFec?.accountableAccounts || [];
    }

    get filteredCompteNums() {
        this.selectedAccountableAccountIndex = 0;
        if (this.onlyUndefinedAccountable) {
            const aas = [];
            for (const aa of this.compteNums) {
                if (!aa.validated || !aa.oss360AAName) {
                    aas.push(aa);
                }
            }
            return aas;
        }
        return this.compteNums;
    }

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get companyBankAccounts() {
        return [...this.companyBankAccountDB, ...this.companyBankAccountCreated];
    }

    get status() {
        let errorCount = 0;
        let warningCount = 0;
        let autoLetteringCount = 0;
        const accountingItems = this.convertFec.accountingItems;

        const filteredAccountingItems = [];
        for (const ai of accountingItems) {
            errorCount += ai.errorCount;
            warningCount += ai.warningCount;
            autoLetteringCount += ai.autoLetteringCount;
        }
        let status = "Statut: ";
        if (errorCount <= 1) {
            status += errorCount + " erreur, ";
        } else {
            status += errorCount + " erreurs, ";
        }
        if (warningCount <= 1) {
            status += warningCount + " alerte, ";
        } else {
            status += warningCount + " alertes, ";
        }
        if (autoLetteringCount <= 1) {
            status += autoLetteringCount + " lettrage auto, ";
        } else {
            status += autoLetteringCount + " lettrages autos, ";
        }
        return status;
    }

    get filteredAccountingItems() {
        const accountingItems = this.convertFec.accountingItems;
        if (!this.onlyError && !this.onlyWarning && !this.onlyAutoLettering) {
            return accountingItems;
        }
        const filteredAccountingItems = [];
        for (const ai of accountingItems) {
            if (this.onlyError && ai.errorCount) {
                filteredAccountingItems.push(ai);
            } else if (this.onlyWarning && ai.warningCount) {
                filteredAccountingItems.push(ai);
            } else if (this.onlyAutoLettering && ai.autoLetteringCount) {
                filteredAccountingItems.push(ai);
            }
        }
        return filteredAccountingItems;
    }

    get companyUsers() {
        return [...this.usersCompanyDB, ...this.usersCompanyCreated];
    }

    get filteredCompanyUsers() {
        if (this.newUser && (this.newUser.firstname || this.newUser.lastname)) {
            const users = [];
            let values = [];
            if (this.newUser.firstname) {
                values = this.newUser.firstname.toLowerCase().split(" ");
            }
            if (this.newUser.lastname) {
                values.push(...this.newUser.lastname.toLowerCase().split(" "));
            }
            values = values.filter((v) => v !== "-" && !v.match(/[1-9]/));
            const regExp = new RegExp(`${values.join("|")}`, "i");
            // if (regExp.test("Roger")) {
            //     console.log("Hourra")
            // }
            for (const user of this.companyUsers) {
                if (user.firstname) {
                    if (regExp.test(user.firstname)) {
                        if (!users.find((u) => u === user)) {
                            users.push(user);
                        }
                    }
                } else if (user.lastname) {
                    if (regExp.test(user.lastname)) {
                        if (!users.find((u) => u === user)) {
                            users.push(user);
                        }
                    }
                }
            }
            return users;
        }
        return this.companyUsers;
    }

    get compExpenseReports() {
        return [];
    }

    get companies() {
        return this.convertFec.companies;
    }

    get bankAccounts() {
        return this.convertFec.bankAccounts;
    }

    get users() {
        return this.convertFec.users;
    }

    get generalLedger() {
        return this.convertFec.generalLedger;
    }

    get generalLedgerWithThirdParty() {
        return this.convertFec.generalLedgerWithThirdParty;
    }

    onThirdPartyChanged(data) {
        this.convertFec.generalLedgerWithThirdParty = data;
    }

    // get errorsBlocks() {
    //     const result = this.blocks.filter(x => x.compatibleTypes.length !== 1)
    //     console.log(result.length === this.blocks.length)
    //     return result
    // }

    get logs() {
        return this.convertFec.logs;
    }

    get companyType() {
        if (
            this.compCompaniesSelected !== null &&
            this.compCompaniesSelected >= 0 &&
            this.compCompaniesSelected < this.companies.length
        ) {
            return this.convertFec.getCompanyType(this.companies[this.compCompaniesSelected].name);
        }
        // debugger
        return { customer: false, supplier: false };
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    get accountingPeriod() {
        return this.convertFec.accountingPeriod;
    }

    set accountingPeriod(value) {
        this.convertFec.setAccountingPeriod(value);
    }

    dbAccountableAccounts: any = [];
    defaultAccountableAccounts = {};

    pasteText = "";

    beforeDestroy() {
        this.removeEventListener();
    }

    removeEventListener() {
        console.log("removeEventListener");
        document.removeEventListener("keydown", this.onPaste);
    }

    addEventListener() {
        console.log("addEventListener");
        document.addEventListener("keydown", this.onPaste);
    }

    async onPaste(ev) {
        const event = ev || window.event; // Event object 'ev'
        if (event) {
            const key = event.which || event.keyCode; // Detecting keyCode
            if (key) {
                console.log("key pressed key= " + key);

                // Detecting Ctrl
                // var ctrl = event.ctrlKey ? event.ctrlKey : ((key === 17) ? true : false);

                // If key pressed is V and if ctrl is true.
                if (key == 86 && event.ctrlKey) {
                    // print in console.
                    console.log("Ctrl+V is pressed.");
                    if (navigator && navigator.clipboard) {
                        const text = await navigator.clipboard.readText();
                        const file = {
                            name: "Données provenant du presse papier.txt",
                            type: "text/plain",
                        };
                        await this.readData(text, file);
                    }
                }
                // else if (key == 67 && ctrl) {

                //     // If key pressed is C and if ctrl is true.
                //     // print in console.
                //     console.log("Ctrl+C is pressed.");
                // }
            }
        }
    }

    dataRead: boolean = false; // onReadDataDone(...) been called at least once at

    async beforeMount() {
        this.addEventListener();
        this.convertFec = new ImportFecFront(this.companyId, this.$apollo, true, !!this.repair);

        // console.log(navigator);
        // const resAA: any = await this.$apollo.query({
        //     query: ACCOUNTABLE_ACCOUNTS_QUERY,
        //     variables: {
        //         companyId: this.companyId
        //     }
        // })
        this.dbAccountableAccounts = this.accountableAccountTable?.accountableAccounts || [];
        this.defaultAccountableAccounts = await getDefaultAccountableAccounts();

        if (this.id) {
            const res: any = await this.$apollo.query({
                query: ACCOUNTING_ITEM_IMPORT,
                variables: {
                    id: this.id,
                },
                fetchPolicy: "network-only",
            });
            if (res && res.data && res.data.accountingItemImport) {
                // const output = await this.convertFec.setAccountingItemImport(this.dbAccountableAccounts, res.data.accountingItemImport)
                const accountingItemImport = _.cloneDeep(res.data.accountingItemImport);

                let result; // = await axios.get(accountingItemImport.signedUrl, {})
                if (
                    accountingItemImport.file.type === "XLSX" ||
                    accountingItemImport.file.type === "XLS"
                ) {
                    result = await axios.get(accountingItemImport.signedUrl, {
                        responseType: "arraybuffer",
                    });
                    const workbook = XLSX.read(result.data, { dateNF: "DD/MM/YYYY" });
                    for (const sheetName of workbook.SheetNames) {
                        result.data = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName]);
                        if (result.data) {
                            break;
                        }
                    }
                } else {
                    result = await axios.get(accountingItemImport.signedUrl, {});
                }

                const columnMapping = accountingItemImport?.data
                    ? accountingItemImport.data.columnMapping
                    : undefined;
                const output = await this.convertFec.readData(
                    result.data,
                    undefined,
                    undefined,
                    columnMapping,
                );
                const inAccountableAccounts = accountingItemImport?.data
                    ? accountingItemImport.data.inAccountableAccounts
                    : undefined;
                await this.onReadDataDone(inAccountableAccounts, accountingItemImport, output);
            }
        }
        this.convertFec.setAccountingFirm(this.accountingFirmId);
    }

    @Apollo({
        query: gql`
            query bankAccount($companyId: ID!) {
                bankAccounts(where: { company: { id: $companyId } }) {
                    id
                    name
                    bank {
                        id
                        name
                    }
                    startAuthorizedDate
                }
            }
        `,
        variables() {
            console.log("Ok Bank");
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.bankAccounts) {
                        this.companyBankAccountDB = data.bankAccounts;
                    }
                }
            }
        },
    })
    companyBankAccountDB: any = [];

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.users) {
                        this.usersCompanyDB = data.users;
                    }
                }
            }
        },
    })
    usersCompanyDB: any = [];

    // @Apollo({
    //     query: ACCOUNTABLE_ACCOUNT_MAPPINGS,
    //     variables() {
    //         return {
    //             accountingFirmId: this.accountingFirmId
    //         }
    //     },
    //     skip() {
    //         return !this.accountingFirmId
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             this.accountingFirmAccountableAccountMappings = data.accountableAccountMappings
    //             this.convertFec.setAccountableAccountMappings(data.accountableAccountMappings)
    //         }
    //     }
    // })
    accountingFirmAccountableAccountMappings: Array<any> = [];

    setThirdParty(company) {
        this.companies[this.compCompaniesSelected].outName = company.name;
        this.companies[this.compCompaniesSelected].id = company.id;
        if (this.companies.length - 1 > this.compCompaniesSelected) this.compCompaniesSelected++;
    }

    getAccountingItemTitle(item) {
        let title = item.index + " | " + this.$t("accountingItem.type." + item.type);
        title += item.errorCount === 1 ? " | " + item.errorCount + " erreur" : "";
        title += item.errorCount > 1 ? " | " + item.errorCount + " erreurs" : "";
        title += item.typeError ? " | " + item.typeError : "";
        title += item.bankAccountError ? " | " + item.bankAccountError : "";
        title += item.companyError ? " | " + item.companyError : "";
        title += item.userError ? " | " + item.userError : "";
        title += item.AIError ? " : " + item.AIError : "";
        title += item.letteringError ? " | " + item.letteringError : "";
        title += item.warningCount === 1 ? " | " + item.warningCount + " alerte" : "";
        title += item.warningCount > 1 ? " | " + item.warningCount + " alertes" : "";
        title += item.AIWarning ? " : " + item.AIWarning : "";
        return title;
    }

    close = function emitToTheParentToCloseTheDialog() {
        this.$emit("close");
    };

    reset() {
        this.convertFec.reset();
    }

    getAccountingItemTypeText(data) {
        return this.$t("accountingItem.type." + data.value);
    }

    computeAccountingPeriodText(accountingPeriod) {
        let text = moment(accountingPeriod.start).format("DD/MM/YYYY");
        text += " / ";
        text += moment(accountingPeriod.end).format("DD/MM/YYYY");
        return text;
    }

    formatDate(date) {
        if (!date) return "";
        // moment.locale("fr");
        return moment(date, "YYYYMMDD").format("DD/MM/YYYY");
    }

    @Apollo({
        query: gql`
            query ($companyId: ID!) {
                accountingPeriods(where: { company: { id: $companyId } }, orderBy: start_ASC) {
                    id
                    start
                    end
                }
            }
        `,
        skip() {
            return !this.companyId;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data && data.accountingPeriods) {
                if (data.accountingPeriods.length) {
                    this.accountingPeriods = data.accountingPeriods;

                    // if (this.accountingPeriods && this.accountingPeriods.length) {
                    //     this.convertFec.accountingPeriod = this.accountingPeriods[this.accountingPeriods.length - 1];
                    // }
                } else {
                    this.convertFec.accountingPeriod = null;
                    this.accountingPeriods = [];
                }
            } else {
                this.convertFec.accountingPeriod = null;
                this.accountingPeriods = [];
            }
        },
        debounce: 500,
    })
    accountingPeriods: any[] = [];

    async onFileChanged(e) {
        this.removeEventListener();
        // debugger
        if (e && e.target && e.target.files) {
            const file = e.target.files[0];
            this.alreadyImported = false;

            this.convertFec.columnMapping = [];

            this.fileName = "";
            this.unknownFormat = true;
            this.formatWasUnkown = true;
            this.unknownFecTitle = "Format d'import inconnu";
            let extension = "";

            const values = file.name.split(".");
            if (values.length >= 2) {
                extension = values[values.length - 1];
            }
            if (extension) {
                extension = extension.toLowerCase();
                this.extension = extension;
            }

            if (extension === "zip") {
                const result: any = await JSZip.loadAsync(file);
                let fileName;
                let acccountableAccountsFileName;
                for (const zipFileName in result.files) {
                    if (!zipFileName) {
                        continue;
                    }
                    if (zipFileName.startsWith("__MACOSX")) {
                        continue;
                    }
                    const zipFile = result.files[zipFileName];
                    if (!zipFile) {
                        continue;
                    }
                    if (zipFile.dir) {
                        continue;
                    }
                    const lcZipFileName = zipFileName.toLowerCase();
                    if (
                        lcZipFileName.endsWith("csv") ||
                        lcZipFileName.endsWith("tsv") ||
                        lcZipFileName.endsWith("txt")
                    ) {
                        if (zipFileName.toLowerCase().startsWith("plan comptable")) {
                            acccountableAccountsFileName = zipFileName;
                        } else {
                            fileName = zipFileName;
                        }
                        if (acccountableAccountsFileName && fileName) {
                            break;
                        }
                        // const data = await zipFile.async("string")
                        // await this.readData(data, {name: zipFileName, type:'text/plain' },file)
                        // break;
                    } else if (lcZipFileName.endsWith("xls") || lcZipFileName.endsWith("xlsx")) {
                        fileName = zipFileName;
                        if (acccountableAccountsFileName && fileName) {
                            break;
                        }
                    }
                }
                if (fileName) {
                    let inAccountableAccounts;
                    if (acccountableAccountsFileName) {
                        const acccountableAccountsFile = result.files[acccountableAccountsFileName];
                        const data = await acccountableAccountsFile.async("string");
                        inAccountableAccounts = await this.convertFec.convetCSVToJson(data);
                    }
                    const zipFile = result.files[fileName];
                    if (
                        fileName.endsWith("csv") ||
                        fileName.endsWith("tsv") ||
                        fileName.endsWith("txt") ||
                        fileName.endsWith("json")
                    ) {
                        const data = await zipFile.async("string");
                        await this.readData(
                            data,
                            { name: fileName, type: "text/plain" },
                            file,
                            inAccountableAccounts,
                        );
                    } else {
                        const data = await zipFile.async("arraybuffer");
                        const result = await excelServices.xlsx2csvFromArrayBuffer(data);
                        await this.readData(
                            result,
                            {
                                name: fileName,
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            },
                            file,
                            inAccountableAccounts,
                        );
                    }
                }
            } else {
                const self = this;
                if (
                    extension === "csv" ||
                    extension === "tsv" ||
                    extension === "txt" ||
                    extension === "json"
                ) {
                    const reader = new FileReader();
                    reader.onload = async function () {
                        if (reader.result) {
                            await self.readData(reader.result, file, undefined, undefined);
                        }
                    };
                    await reader.readAsText(file);
                } else {
                    const result = await excelServices.xlsx2csv(file);
                    console.log(file.type);
                    await self.readData(result, file);
                }
            }
        }
    }

    async onReadDataDone(inAccountableAccounts, aii, output) {
        const error = output.error;
        if (output.unknownFormat) {
            this.unknownFecTitle = error;
            this.formatWasUnkown = output.unknownFormat;
            this.unknownFormat = true;
            this.readingError = "";
        } else {
            this.unknownFormat = false;
            this.formatWasUnkown = false;
            this.unknownFecTitle = "";
            this.readingError = error;
        }

        this.inAccountableAccounts = inAccountableAccounts;

        if (aii) {
            this.convertFec.importTitle = aii.name;
        }
        if (!this.readingError && !this.formatWasUnkown) {
            this.aii = aii;
            const errorMessage = await this.convertFec.setData(
                {
                    aaCharacterCount: this.accountableAccountTable.aaCharacterCount,
                    dbAccountableAccounts: this.dbAccountableAccounts,
                    defaultAccountableAccounts: this.defaultAccountableAccounts,
                    inAccountableAccounts: this.inAccountableAccounts,
                },
                aii,
                output.data,
                this.payslipOnly,
            );
            if (errorMessage) {
                this.readingError = errorMessage;
            }
        }
        if (!this.readingError) {
            this.outputData = output;
            this.aii = aii;
        } else {
            debugger;
        }
        this.dataRead = true;
    }

    outputData = null;

    async readSilaeJson(data, file) {}

    async readData(data, file, zipFile = undefined, inAccountableAccounts = undefined) {
        this.reset();
        // const self = this;

        const values = file.name.split(".");
        this.fileName = values[0];

        const sha256 = SHA256(data).toString();
        const resultQ = await this.$apollo.query({
            query: ACCOUNTING_ITEM_IMPORT_FROM_FILE,
            fetchPolicy: "network-only",
            variables: {
                companyId: this.companyId,
                sha256: sha256,
            },
        });
        let aii = null;
        if (
            resultQ &&
            resultQ.data &&
            resultQ.data.accountingItemImports &&
            resultQ.data.accountingItemImports.length
        ) {
            aii = _.cloneDeep(resultQ.data.accountingItemImports[0]);
        }
        if (aii && aii.status === "IMPORTED") {
            this.alreadyImported = true;
        } else {
            const result = data.toString();
            this.wrongFormat = !this.convertFec.checkFormat(result);
            if (!this.wrongFormat) {
                file.sha256 = sha256;
                const output = await this.convertFec.readData(result, file, zipFile, undefined);
                // readingError detects unvalid dates and stops disables "Next" Button
                await this.onReadDataDone(inAccountableAccounts, aii, output);

                //console.log(output.data)
            }
        }
        this.readingFinished = true;
    }

    verifyFEC(itemsSelection) {
        for (const line of this.importedItems) {
            if (line.PieceDate) {
                line.PieceDate = this.getDate(line.PieceDate);
            }
            if (line.EcritureDate) {
                line.EcritureDate = this.getDate(line.EcritureDate);
            }
            if (line.DateLet) {
                line.DateLet = this.getDate(line.DateLet);
            }
            if (line.dueDate) {
                line.dueDate = this.getDate(line.dueDate);
            }
        }
        const columnMapping = itemsSelection.map((header, index) => {
            return { text: "", type: header.type, value: header.value, csv: header.import };
        });
        this.convertFec.columnMapping = columnMapping;
    }

    async onColumnsChosen(data) {
        debugger;
        const { importedItems, importedSelection, foundErrors } = data;
        this.importedItems = importedItems;
        await this.verifyFEC(importedSelection);
        if (!foundErrors.length) {
            this.unknownFormat = false;
            this.unknownFecTitle = "Format d'import connu";
            await this.convertFec.setData(
                {
                    aaCharacterCount: this.accountableAccountTable.aaCharacterCount,
                    defaultAccountableAccounts: this.defaultAccountableAccounts,
                    dbAccountableAccounts: this.dbAccountableAccounts,
                    inAccountableAccounts: this.inAccountableAccounts,
                },
                this.aii,
                this.importedItems,
                this.payslipOnly,
            );
            this.wizardStep = 1;
        }
    }

    autoFillCompany() {
        this.convertFec.autoFillCompanies();
    }

    previous = function goToThePreviousWindowItem() {
        this.wizardStep--;
        if (this.wizardStep === -1) {
            if (/*this.extension === "csv" && */ this.formatWasUnkown) {
                if (this.columnComponent.wizardStep === 0) {
                    this.wizardStep = -1;
                } else if (this.columnComponent.wizardStep === 1) {
                    if (this.convertFec.columnMapping?.length) {
                        this.wizardStep = -1;
                    } else {
                        this.wizardStep = 0;
                        this.columnComponent.wizardStep = 0;
                    }
                }
            } else {
                this.addEventListener();
            }
        }
        if (this.wizardStep === 0) {
            if (!this.formatWasUnkown) {
                this.wizardStep = -1;
            }
        }
        // if (this.wizardStep === 2) {
        // }
        if (this.wizardStep === 3) {
            if (!this.bankAccounts.length) {
                this.previous();
            }
        }
        if (this.wizardStep === 4) {
            if (!this.users.length) {
                this.previous();
            }
        }
        if (this.wizardStep === 5) {
            if (!this.companies.length) {
                this.previous();
            }
        }
    };

    removeType = function deletionOfThePossibleTypeInTheLog(type, index) {
        this.journalCodes[index].types = this.journalCodes[index].types.filter((x) => x !== type);
    };

    addType = function additionOfThePossibleTypeInTheLog(type, index) {
        const positionType = this.journalCodes[index].types.indexOf(type);
        if (positionType === -1) {
            this.journalCodes[index].types = _.union(this.journalCodes[index].types, [type]);
        } else {
            this.journalCodes[index].types.splice(positionType, 1);
        }
    };

    isInJournal(type) {
        const positionType = this.journalCodes[this.journalCodeSelected].types.indexOf(type);
        return positionType !== -1;
    }

    isAllTypesDefined() {
        for (const log of this.logs) {
            for (const aaKey of log.aaKeys) {
                if (aaKey.type === undefined) {
                    return false;
                }
            }
        }
        return true;
    }

    disabledNext() {
        if (!this.outputData) {
            return true;
        }
        if (this.wrongFormat || this.readingError) {
            return true;
        }
        // if (this.convertFec.accountingPeriod && this.editable && this.importCarryForward === null) {
        //     return true
        // }
        switch (this.wizardStep) {
            case -1:
                return this.alreadyImported;
            case 0: {
                if (this.$refs.columnComponent) {
                    if (
                        (!this.columnComponent.allColumnsPresent ||
                            !this.columnComponent.allDatesValid) &&
                        this.columnComponent?.wizardStep === 1
                    ) {
                        return true;
                    }
                    return false;
                }
                break;
            }
            case 1: {
                if (!this.dataAvailable) return true;
                for (const accAccount of this.compteNums) {
                    if (!accAccount.oss360AAName || !accAccount.validated) {
                        return true;
                    }
                }
                return false;
            }
            case 2: {
                return !this.isAllTypesDefined();
                //  for (const code of this.journalCodes) {
                //     if (!code.groupSelected) {
                //         return true
                //     }
                // }
                // return false
            }
            case 3: {
                if (this.editable) {
                    for (const bank of this.bankAccounts) {
                        if (!bank.outName) {
                            return true;
                        }
                    }
                }
                return false;
            }
            case 4: {
                if (this.editable) {
                    for (const user of this.users) {
                        if (!user.firstname && !user.lastname) {
                            return true;
                        }
                    }
                }
                return false;
            }
            case 5: {
                if (this.editable) {
                    for (const company of this.companies) {
                        if (!company.outName) {
                            return true;
                        }
                    }
                }
                return false;
            }
            // case 5: {
            //     return !this.convertFec.isValid()
            // }
        }
        return false;
    }

    next = async function goToTheNextWindowItem(upsert: boolean = true) {
        if (upsert && this.wizardStep >= 0 && this.wizardStep <= 5) {
            if (!this.unknownFormat) {
                this.loadingUpsertAAI = true;
                await this.convertFec.upsertAccountingItemImport(this.companyId);
                this.loadingUpsertAAI = false;
            }
        }
        if (this.wizardStep === -1) {
            this.removeEventListener();
        }
        this.wizardStep++;

        if (this.wizardStep === 0) {
            if (!this.formatWasUnkown) {
                this.wizardStep = 1;
            }
        }
        if (this.wizardStep === 1) {
            if (this.$refs.columnComponent && this.formatWasUnkown) {
                this.wizardStep = 0;
                if (this.$refs.columnComponent.wizardStep === 0) {
                    await this.$refs.columnComponent.previewData();
                    this.$refs.columnComponent.wizardStep = 1;
                } else if (this.$refs.columnComponent.wizardStep === 1) {
                    this.$refs.columnComponent.processData();
                }
            }
            // if (this.unknownFormat) {
            //     this.setDataOnUserInput()
            // }
        }
        if (this.wizardStep === 2) {
            this.convertFec.analyseAccountingTransactions();
        }
        // if (this.wizardStep === 2) {
        //     // if (this.payslipOnly) {
        //     //     this.next();
        //     //     return;
        //     // }
        // }
        //
        // bankAccounts
        //
        if (this.wizardStep === 3) {
            if (!this.bankAccounts.length) {
                this.next(false);
                return;
            }
        }
        //
        // user
        //
        if (this.wizardStep === 4) {
            if (!this.users.length) {
                this.next(false);
                return;
            }
            this.compCompaniesSelected = 0;
        }
        //
        // companies
        //
        if (this.wizardStep === 5) {
            if (!this.companies.length) {
                this.next(false);
                return;
            }
        }
        if (this.wizardStep === 6) {
            this.convertFec.compute();
        }

        if (this.wizardStep === 8) {
            this.loadingImport = false;
        }
    };

    createNewBank = function creatingANewBankAccount() {
        this.companyBankAccountCreated.push({
            name: this.newBankName,
            id: null,
        });
        // this.users[this.bankSelected].user = {
        //     name: this.newBankName,
        //     id: null
        // }
        this.newBankName = "";
    };

    nextEmptyAccountableAccount() {
        if (!this.onlyUndefinedAccountable) {
            let counter = 0;
            let index = this.selectedAccountableAccountIndex + 1;
            if (index >= this.filteredCompteNums.length) {
                index = 0;
            }
            while (counter < this.filteredCompteNums.length) {
                const accAccount = this.filteredCompteNums[index];
                if (!accAccount.oss360AAName || !accAccount.validated) {
                    this.selectedAccountableAccountIndex = index;
                    break;
                }
                index++;
                if (index >= this.filteredCompteNums.length) {
                    index = 0;
                }
                counter++;
            }
        }
    }

    get selectedAccountableAccount() {
        if (
            this.selectedAccountableAccountIndex >= 0 &&
            this.selectedAccountableAccountIndex < this.filteredCompteNums.length
        ) {
            return this.filteredCompteNums[this.selectedAccountableAccountIndex];
        }
        return null;
    }

    setAccountableAccount(name) {
        if (this.selectedAccountableAccount) {
            this.selectedAccountableAccount.oss360AAName = name;
            this.selectedAccountableAccount.validated = true;
            this.convertFec.identifyTag(this.selectedAccountableAccount);
            this.nextEmptyAccountableAccount();
        }
    }

    validateAccountableChoice(num) {
        if (num.oss360AAName) {
            const prevValidated = num.validated;
            num.validated = !num.validated;
            if (!prevValidated) {
                this.nextEmptyAccountableAccount();
            }
        }
    }

    nextUser() {
        let counter = 0;
        let index = this.userSelected + 1;
        if (index >= this.users.length) {
            index = 0;
        }

        // for (let ui = this.userSelected + 1; ui < this.users.length; ui++) {
        while (counter < this.users.length) {
            const user = this.users[index];
            if (!user || (!user.id && !user.firstname && !user.lastname)) {
                this.setUserSelected(index);
                break;
            }
            index++;
            if (index >= this.users.length) {
                index = 0;
            }
            counter++;
        }
    }

    createUser() {
        console.log(this);
        console.log(this.newUser);
        if (this.newUser?.lastname) {
            this.usersCompanyCreated.push(this.newUser);
            // this.users[this.userSelected].user = this.newUser
            const compUser = this.users[this.userSelected];
            compUser.firstname = this.newUser.firstname;
            compUser.lastname = this.newUser.lastname;
            compUser.id = "";
            this.newUser = {
                firstname: "",
                lastname: "",
            };
            this.nextUser();
        }
    }

    addUser(user) {
        if (this.userSelected < 0 || this.userSelected > this.users.length) {
            debugger;
            return;
        }
        const compUser = this.users[this.userSelected];
        compUser.firstname = user.firstname;
        compUser.lastname = user.lastname;
        compUser.id = user.id;
        this.nextUser();
    }

    formatTypesSelect = function formattingTypesForTheSelector(values: Array<any>) {
        return values.map((x) => ({ text: this.$t("accountingItem.type." + x), value: x }));
    };

    getCellStyle(item, att) {
        if (item[att + "Error"]) {
            return "color:#ff6b6b; font-weight: bold;";
        }
        if (item[att + "Warning"]) {
            return "color:orange; font-weight: bold;";
        }
        return "text-align: center";
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getRowDebit(row) {
        if (row.debit) {
            if (row.result.debit) return newCommonFormatCurrency(row.result.debit);
            return newCommonFormatCurrency(row.debit);
        } else if (row.debit === 0 || row.debit === "0.00") {
            return "-";
        }
        return "";
    }

    getRowCredit(row) {
        if (row.credit) {
            if (row.result.credit) return newCommonFormatCurrency(row.result.credit);
            return newCommonFormatCurrency(row.credit);
        } else if (row.credit === 0 || row.credit === "0.00") {
            return "-";
        }
        return "";
    }

    isValid() {
        if (this.convertFec) {
            return this.convertFec.isValid();
        }
        return false;
    }

    inBankGroup(journal) {
        const bankGroup = ["BANK_TRANSACTION"];
        return bankGroup.indexOf(journal) !== -1;
    }

    bankGroup(types) {
        const group = [];
        for (const type of types) {
            if (this.inBankGroup(type)) group.push(type);
        }
        return group;
    }

    inSalesGroup(journal) {
        const salesGroup = ["SALES_INVOICE", "ZTILL_RECEIPT"];
        return salesGroup.indexOf(journal) !== -1;
    }

    salesGroup(types) {
        const group = [];
        for (const type of types) {
            if (this.inSalesGroup(type)) group.push(type);
        }
        return group;
    }

    inPurchaseGroup(journal) {
        const purchaseGroup = [
            "PURCHASE_INVOICE",
            "CURRENT_ACCOUNT",
            "OPERATOR_ACCOUNT",
            "EXPENSE_REPORT",
            "PAY_SLIP",
        ];
        return purchaseGroup.indexOf(journal) !== -1;
    }

    purchaseGroup(types) {
        const group = [];
        for (const type of types) {
            if (this.inPurchaseGroup(type)) group.push(type);
        }
        return group;
    }

    inMiscellaneousOperationGroup(journal) {
        const miscellaneousOperationGroup = ["MISCELLANEOUS_OPERATION"];
        return miscellaneousOperationGroup.indexOf(journal) !== -1;
    }

    miscellaneousOperationGroup(types) {
        const group = [];
        for (const type of types) {
            if (this.inMiscellaneousOperationGroup(type)) group.push(type);
        }
        return group;
    }

    inCarryForwardGroup(journal) {
        const carryForwardGroup = ["CARRY_FORWARD"];
        return carryForwardGroup.indexOf(journal) !== -1;
    }

    carryForwardGroup(types) {
        const group = [];
        for (const type of types) {
            if (this.inCarryForwardGroup(type)) group.push(type);
        }
        return group;
    }

    inVATGroup(journal) {
        const vatGroup = ["VAT"];
        return vatGroup.indexOf(journal) !== -1;
    }

    vatGroup(types) {
        const group = [];
        for (const type of types) {
            if (this.inVATGroup(type)) group.push(type);
        }
        return group;
    }

    loadingImport = false;

    async valid() {
        console.log("valid");
        this.loadingImport = true;
        // await this.convertFec.import();
        await this.convertFec.import(this.companyId, false);

        this.loadingImport = false;
        // this.reset();
        this.$router.push({ name: "accountingItems" });
    }

    setGroupSelected(code, groupName) {
        code.groupSelected = groupName;

        switch (groupName) {
            case "bank":
                code.types = this.bankGroup(this.journalCodes[this.journalCodeSelected].autoTypes);
                break;
            case "sales":
                code.types = this.salesGroup(this.journalCodes[this.journalCodeSelected].autoTypes);
                break;
            case "purchase":
                code.types = this.purchaseGroup(
                    this.journalCodes[this.journalCodeSelected].autoTypes,
                );
                break;
            case "miscellaneousOperation":
                code.types = this.miscellaneousOperationGroup(
                    this.journalCodes[this.journalCodeSelected].autoTypes,
                );
                break;
            case "carryForward":
                code.types = this.carryForwardGroup(
                    this.journalCodes[this.journalCodeSelected].autoTypes,
                );
                break;
            case "vat":
                code.types = this.vatGroup(this.journalCodes[this.journalCodeSelected].autoTypes);
                break;
        }
    }

    displayNominalAccountableAccount(name) {
        if (name) {
            return name.slice(0, 4);
        } else {
            return "XXXX";
        }
    }

    getOriginalDescription(num) {
        return (
            num.desc || (num.wordings && num.wordings.length ? "Libellé : " + num.wordings[0] : "")
        );
    }

    isGeneralAccountableAccount(accountableAccount) {
        return this.convertFec.isGeneralAccountableAccount(accountableAccount);
    }

    subAccount(name) {
        if (name) {
            return name.slice(4, name.length);
        } else {
            return "XXXX";
        }
    }

    onLogTypesChanged(log) {
        for (let index = 0; index < log.types.length; index++) {
            const logType = log.types[index];
            const disabled = log.selectedTypes.indexOf(index) === -1;
            for (const aaKey of log.aaKeys) {
                const typeIndex = aaKey.possibleTypes.findIndex((pt) => pt.type === logType);
                if (typeIndex !== -1) {
                    aaKey.possibleTypes[typeIndex].disabled = disabled;
                    if (disabled && aaKey.type === typeIndex) {
                        aaKey.type = undefined;
                    }
                }
            }
        }
        //
        // set type if possible
        //
        for (const aaKey of log.aaKeys) {
            if (aaKey.type === undefined) {
                let count = 0;
                let lastAvailableIndex;
                for (let index = 0; index < aaKey.possibleTypes.length; index++) {
                    if (index !== undefined) {
                        const pt = aaKey.possibleTypes[index];
                        if (!pt.disabled) {
                            count++;
                            lastAvailableIndex = index;
                        }
                    }
                }
                if (count === 1 && lastAvailableIndex !== undefined) {
                    aaKey.type = lastAvailableIndex;
                }
            }
        }
        this.refreshKey++;
    }

    getAAKeyWithoutTypeCount(log) {
        let count = 0;
        for (const aaKey of log.aaKeys) {
            if (aaKey.type === undefined) {
                count++;
            }
        }
        return count;
    }

    get containsDateDifferenceErrors() {
        return this.convertFec.containsDateDifferenceErrors;
    }

    correctDateDifferenceErrors() {
        this.convertFec.correctDateDifferenceErrors();
    }

    onAccountingItemDateChanged(accountingItem) {
        this.convertFec.onAccountingItemDateChanged(accountingItem);
    }

    onAccountingItemTypeChanged(accountingItem) {
        this.convertFec.onAccountingItemTypeChanged(accountingItem);
    }

    computeFirstNameLastName(name, user) {
        if (!name) {
            return;
        }
        const pattern = /^[A-Z]{1,}$/;
        const values = name.split(" ");
        let i = 0;
        for (; i < values.length; i++) {
            if (!values[i].match(pattern)) {
                break;
            }
        }
        if (i) {
            for (let j = 0; j < i; j++) {
                if (user.lastname) user.lastname += " ";
                user.lastname += values[j];
            }
            for (let j = i; j < values.length; j++) {
                if (user.firstname) user.firstname += " ";
                user.firstname += values[j];
            }
            return;
        }
        i = values.length - 1;
        for (; i >= 0; i--) {
            if (!values[i].match(pattern)) {
                break;
            }
        }
        if (i < values.length - 1) {
            for (let j = 0; j <= i; j++) {
                if (user.firstname) user.firstname += " ";
                user.firstname += values[j];
            }
            for (let j = i + 1; j < values.length; j++) {
                if (user.lastname) user.lastname += " ";
                user.lastname += values[j];
            }
            return;
        }
        user.lastname = name;
    }

    setUserSelected(index) {
        this.userSelected = index;
        const user = this.users[index];

        this.newUser.firstname = user.firstname || "";
        this.newUser.lastname = user.lastname || "";
        if (!this.newUser.firstname && !this.newUser.lastname) {
            this.computeFirstNameLastName(user.name, this.newUser);
        }
    }

    getRequiredColumnsByType(type: string) {
        const minimumReqired = ["id", "aaName", "date", "wording", "debit", "credit"];
        switch (type) {
            case "PURCHASE_INVOICE":
                minimumReqired.push("thirdPartyCompany");
                break;
            case "SALES_INVOICE":
                minimumReqired.push("thirdPartyCompany");
                break;
            case "BANK_TRANSACTION":
                minimumReqired.push("bankAccount");
                break;
            case "ZTILL_RECEIPT":
                break;
            case "CURRENT_ACCOUNT":
                minimumReqired.push("lastname");
                break;
            case "OPERATOR_ACCOUNT":
                minimumReqired.push("lastname");
                break;
            case "EXPENSE_REPORT":
                minimumReqired.push("lastname");
                break;
            case "PAY_SLIP":
                minimumReqired.push("lastname");
                break;
            case "MISCELLANEOUS_OPERATION":
                break;
            case "CARRY_FORWARD":
                break;
            case "VAT":
                break;
            case "OD":
                break;
            // default: {
            //     console.error(`${ type } is not referenced`)
            // }
        }
        return minimumReqired;
    }

    getMinimuRequiredColumns(typesList: string[]) {
        return _.uniq(_.uniq(typesList).flatMap((type) => this.getRequiredColumnsByType(type)));
    }

    getItem(item) {
        return this.indexViewed >= 0 && this.indexViewed < item.example.length
            ? item.example[this.indexViewed]
            : "";
    }

    getAccountingPeriodTitle() {
        let title = "Exercice associé à l'import ";
        if (this.containsCarryForward) {
            title += "(obligatoire)";
        } else {
            title += "(optionnel)";
        }
        return title;
    }

    getOss360AAWording(num) {
        let wording = "";
        if (num.oss360AAName) {
            const dbAA = this.dbAccountableAccounts.find((aa) => aa.name === num.oss360AAName);
            if (dbAA) {
                wording = dbAA.description;
            } else {
                const defaultAA = this.defaultAccountableAccounts[num.oss360AAName];
                if (defaultAA) {
                    wording = defaultAA.description;
                }
            }
        }

        wording += num.tagType
            ? (num.tagType === 1 ? " - Tag : " : " -> Sous compte : ") + num.tag
            : "";

        return wording;
    }

    // ---------------------------------------------------------------------------------------------
    // ----------------------- V-WINDOW 1 : force-valid-compte-nums-btn ----------------------------
    // ---------------------------------------------------------------------------------------------
    forceValidCompteNumsBtnLabel = `Compléter automatiquement`;

    isForceValidCompteNumsInProgress = false;

    forceValidCompteNums() {
        this.isForceValidCompteNumsInProgress = true;
        for (const aa of this.compteNums) {
            const oss360Name = aa?.oss360AAName ?? "";
            const forceValidPossible = oss360Name.length && !aa.validated;
            if (forceValidPossible) aa.validated = true;
        }
        setTimeout(() => {
            this.isForceValidCompteNumsInProgress = false;
        }, 500);
    }
    // ---------------------------------------------------------------------------------------------

    file = null;
    async testMaxime() {
        debugger;
        await this.$apollo.mutate({
            mutation: IMPORT_FEC_AUTO,
            variables: {
                companyId: this.companyId,
                withAccountingItemImport: false,
                accountingItemImportId: this.aii?.id || this.convertFec.accountingItemImport?.id,
                fileName: this.fileName,
                file: this.file,
            },
        });
    }
}

export default toNative(ImportFEC);
</script>

<style lang="scss" scoped>
.v-window-1-v-virtual-scroll {
    opacity: 1;
    transition: opacity 1s ease;

    &--hidden {
        opacity: 0;
    }
}
</style>
